// extracted by mini-css-extract-plugin
export default {"zendesk_chat_conatiner":"styles_zendesk_chat_conatiner__xtH0v","chat_icon":"styles_chat_icon__Y3i3s","zendesk_icon":"styles_zendesk_icon__aSTKG"};